import axios from 'axios'

export default {
    getCategory(){
        return axios.get('/category')
            .then(response => {
                return response.data
            })
    },
    getCategoryDataSource(params){
        return axios.get('/category/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getCategorybyID(id){
        return axios.get('/category/' + id)
            .then(response => {
                return response.data
            })
    },    
    createCategory(formdata){
        return axios.post('/category', formdata)
            .then(response => {
                return response.data
            })
    },
    updateCategory(id,formdata){
        return axios.put('/category/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateCategory(id){
        return axios.put('/category/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateCategory(id){
        return axios.put('/category/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
}